import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, DialogContent } from '@mui/material';
import { DataModalHeader } from './data-modal-header.tsx';
import { DataModalForm } from './data-modal-form.tsx';
import { RegridResponse } from '../../../../models/regrid.model.tsx';
import { PropertyDetailsResponseData } from '../../../../models/details.models.tsx';

interface DataModalProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  regridData: RegridResponse | undefined;
  propertyData: PropertyDetailsResponseData | undefined;
  mlsImage?: string;
}

export const DataModal = (props: DataModalProps) => {
  const { isOpen, setIsOpen, regridData, propertyData } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Dialog
        data-testid="data-modal"
        className="data-modal"
        fullScreen={fullScreen}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="data-modal-title"
        fullWidth
        maxWidth="lg"
        sx={{
          minWidth: { xs: 'initial', sm: '100%' },
          maxWidth: { xs: 'initial', sm: '100%' },
        }}
      >
        <Box
          className="container"
          sx={{ minWidth: { xs: 'initial', sm: '100%' } }}
        >
          <DataModalHeader setIsOpen={setIsOpen} title={'Data Sheet'} />
          <DialogContent className="content">
            {
              <DataModalForm
                regridData={regridData}
                propertyData={propertyData}
                mlsImage={props.mlsImage}
              />
            }
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
